module.exports = __webpack_public_path__ + "img/core-1.9f4e695b.png";